<div class="mt-4" [hidden]="!loading">
  <div class="progress-spinner-container">
    <div class="progress-spinner-content">
      <mat-progress-spinner mode="indeterminate" color="primary" diameter="75"></mat-progress-spinner>
    </div>
  </div>
</div>


<div class="container-fluid" *ngIf="history">
  <div *ngIf="history" class="row">
    <div class="col-sm-12">
      <mat-card class="mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h5 class="m-0">
              <span class="conversation-title">Dialog activity</span>
              <span *ngIf="history.agentName !=null && history.agentName !=''">
                :&nbsp; {{history.agentName}}
              </span>
            </h5>
          </div>

          <div *ngIf="history.recordingUrl != null  && voiceCallId == null" class="d-flex">
            <div class="ml-1">Play audio file &nbsp; &nbsp;</div>

            <audio controls
                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                   preload='auto'
                   class="play-recording" id="audio-{{history.id}}">
              <source src="{{history.recordingUrl}}" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>
          </div>

          <div class="d-flex justify-content-end align-items-start">
            <button *ngIf="conversationId" mat-raised-button color="primary" (click)="close()">
              <i class="lni-arrow-left small mb-1"></i>&nbsp;&nbsp;Back to dialogs
            </button>

            <button *ngIf="voiceCallId" mat-raised-button color="primary" (click)="close()">
              <i class="lni-arrow-left small mb-1"></i>&nbsp;&nbsp;Back to activity
            </button>
          </div>

        </div>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3">
      <mat-card class="mt-3 h-100 small">
        <h5>SUMMARY</h5>

        <div class="box">
          <div *ngIf="conversationId" class="mt-3">
            <div>
              <b>Details</b>
            </div>

            <div>
              <span class="text-gray-dark">Started on: &nbsp; </span>
              <span>
                {{history.startedOnUtc | date:'d/MM/yyyy' }}
                {{timeZoneId=='UTC'? (history.startedOnUtc | date:'HH:mm':"+0000"):(history.startedOnUtc | date:'HH:mm') }}
              </span>
            </div>

            <div class="mt-1">
              <span class="text-gray-dark">Ended on: &nbsp; </span>
              <span>
                {{history.endedOnUtc | date:'d/MM/yyyy' }}
                {{timeZoneId=='UTC'? (history.endedOnUtc | date:'HH:mm':"+0000"):(history.endedOnUtc | date:'HH:mm') }}
              </span>
            </div>
            <div class="mt-1">
              <span class="text-gray-dark">Duration: &nbsp; </span>
              <span>{{history.duration}} </span>
            </div>
            <div class="mt-1">
              <span class="text-gray-dark">Direction: &nbsp;</span>
              <span>{{history.direction}} </span>
            </div>
            <div class="mt-1">
              <span class="text-gray-dark">Call id: &nbsp;</span>
              <span>{{history.requestId}} </span>
            </div>
            <div class="mt-1">
              <span class="text-gray-dark">User phone number:&nbsp; </span>
              <span>{{history.contact}} </span>
            </div>

            <div class="mt-1" *ngIf="history.source!=null && history.source!=''">
              <span class="text-gray-dark">DID: &nbsp;</span>
              <span>{{history.source}} </span>
            </div>

            <div class="mt-1" *ngIf="history.llmEngine!=null && history.llmEngine!=''">
              <span class="text-gray-dark">LLM Engine: &nbsp;</span>
              <span>{{history.llmEngine}} </span>
            </div>

            <div class="mt-1" *ngIf="history.model!=null && history.model!=''">
              <span class="text-gray-dark">Model: &nbsp;</span>
              <span>{{history.model}} </span>
            </div>

            <div class="mt-1" *ngIf="history.delegationModel!=null && history.delegationModel!=''">
              <span class="text-gray-dark">Delegation model: &nbsp;</span>
              <span>{{history.delegationModel}} </span>
            </div>
            <div class="mt-1" *ngIf="languageName!=null && languageName!=''">
              <span class="text-gray-dark">Language: &nbsp;</span>
              <span>{{languageName}} </span>
            </div>
            <div class="mt-1" *ngIf="history.voice!=null && history.voice!=''">
              <span class="text-gray-dark">Voice: &nbsp;</span>
              <span>{{history.voice}} </span>
            </div>
          </div>

          <div *ngIf="conversationId" class="my-3">
            <mat-divider></mat-divider>
          </div>

          <div *ngIf="voiceCallId !=null && history.recordings!=null && history.recordings.length > 0 " class="container p-0 recording-container">
            <div class="mb-3"><b>Recodings</b></div>
            <div class="row" *ngFor="let list of history.recordings">
              <div class="col-sm-7">
                <span class="text-gray-dark">{{list.agentName}}: &nbsp;</span>
              </div>
              <div class="col-sm-5">
                <div class="d-flex">
                  <div> <app-mini-audio-player [src]="list.url"></app-mini-audio-player></div>
                  <div class="ml-2" *ngIf="list.advancedTranscription==true">
                    <div class="full-height align-content-center"><a [href]="list.transcriptionUrl" target="_blank" title="Advanced transcription"><span class="lni lni-comment"></span></a></div>
                  </div>
                </div>
                
              </div>
              </div>
            </div>

          <div *ngIf="voiceCallId !=null" class="my-3">
            <mat-divider></mat-divider>
          </div>

          <div *ngIf="history.tokenUsageList!=null && history.tokenUsageList.length>0">
            <div>
              <b>Usage</b>
            </div>
            <div class="mt-2" *ngFor="let section of tokenUsageSections">
              <u><b class="usage-section-title">{{section.name}}</b></u>
              <div *ngFor="let item of section.items">
                <span class="text-gray-dark">{{item.label}}: &nbsp;</span>
                <span>{{item.value}} {{item.unit}}</span>
              </div>
            </div>

            <div class="my-3">
              <mat-divider></mat-divider>
            </div>
          </div>


          <div class="mt-3">
            <div>
              <b>Input</b>
            </div>

            <div *ngIf="history.inputs && (history.inputs | keyvalue).length > 0; else noInputs">
              <div *ngFor="let item of history.inputs | keyvalue">
                <span class="text-gray-dark">{{item.key}}</span>: {{item.value}}
              </div>
            </div>
            <ng-template #noInputs>
              <div class="no-data">
                No data available.
              </div>
            </ng-template>
          </div>

          <div class="my-3">
            <mat-divider></mat-divider>
          </div>

          <div>
            <div>
              <b>Output</b>
            </div>

            <div *ngIf="history.collectedData?.length > 0; else noEntities">
              <div *ngFor="let item of history.collectedData">
                <span class="text-gray-dark">{{ item.name }}</span>: {{ item.value }}
              </div>
            </div>
            <ng-template #noEntities>
              <div class="no-data">
                No data available.
              </div>
            </ng-template>
          </div>

          <!--<div class="my-3">
            <mat-divider></mat-divider>
          </div>-->
          <!--<div>
            <div>
              <b>Evaluation criteria</b>
            </div>

            <div *ngIf="history.evaluationCriteria?.length > 0; else noCriteria">
              <ng-container *ngFor="let crit of history.evaluationCriteria">
                <div class="d-flex justify-content-between">
                  <span>{{ crit.name }}</span>

                  <span>
                    <span class="status-badge success" *ngIf="crit.status == criteriaStatus.Success">Successful</span>
                    <span class="status-badge failure" *ngIf="crit.status == criteriaStatus.Failure">Failure</span>
                    <span class="status-badge unknown" *ngIf="crit.status == criteriaStatus.Unknown">Unknown</span>
                  </span>
                </div>
              </ng-container>
            </div>
            <ng-template #noCriteria>
              <div class="no-data">
                No data available.
              </div>
            </ng-template>
          </div>-->
        </div>
      </mat-card>
    </div>

    <div class="col-sm-9">
      <mat-card class="mt-3 h-100">
        <h5>CONVERSATION</h5>

        <div class="box">
          <div class="chat-container p-2">
            <div *ngFor="let msg of history.conversation; let i = index">

              <!-- MESSAGE-->
              <div class="chat-message" [ngClass]="msg.item.participantType" *ngIf="msg.type=='Message' && msg.item !=null">
                <div class="message-text">{{ msg.item.text }}</div>
                <ng-container *ngIf="showParticipant(i)">
                  <ng-container *ngIf="msg.item.participantType == 'User'; else agent">
                    <div class="message-participant ml-1">Customer</div>
                  </ng-container>
                  <ng-template #agent>
                    <div class="message-participant mr-1">Agent <span *ngIf="msg.item.agentName != null && msg.item.agentName !=''">"{{msg.item.agentName}}"</span></div>
                  </ng-template>
                </ng-container>
              </div>

              <!-- TOOL CALLS -->
              <div class="chat-message Agent" *ngIf="msg.type=='FunctionCall' && msg.item != null">
                <ng-container *ngIf="msg.item as tool">
                  <div class="message-text">
                    <div class="tool-call-header d-flex align-items-center">

                      <ng-container *ngIf="tool.functionName === 'TransferToAIAgent' || tool.functionName === 'TransferToHuman'; else normalHeader">
                        <i class="material-icons icon-inline tool-success">check_circle</i>
                        <span class="ml-1">
                          <b class="tool-success-text">Execution succeeded: </b> {{tool.functionName}}
                        </span>
                        <ng-container *ngIf="tool.url">
                          <span class="mx-1 text-gray-400">|</span>
                          <span class="break-long-text">{{ tool.url }}</span>
                        </ng-container>
                      </ng-container>

                      
                      <ng-template #normalHeader>
                        <i class="material-icons icon-inline" [ngClass]="isToolSuccess(tool) ? 'tool-success' : 'tool-error'">
                          {{ isToolSuccess(tool) ? 'check_circle' : 'cancel' }}
                        </i>

                        <span class="ml-1">
                          <b [ngClass]="isToolSuccess(tool) ? 'tool-success-text' : 'tool-error-text'">
                            {{ isToolSuccess(tool) ? 'Execution succeeded:' : 'Execution failed:' }}
                          </b>
                          {{ tool.functionName }}
                        </span>

                        <ng-container *ngIf="showToggleButton(tool)">
                          <span class="mx-1 text-gray-400">|</span>
                          <button type="button" class="btn btn-link p-0" (click)="toggleTool(i)">
                            {{ expandedTools[i] ? 'Hide details' : 'See details' }}
                          </button>
                        </ng-container>

                        <ng-container *ngIf="showUrlOnly(tool)">
                          <span class="mx-1 text-gray-400">|</span>
                          <span class="break-long-text">{{ tool.url }}</span>
                        </ng-container>
                      </ng-template>

                    </div>

                    <div class="tool-call-details" *ngIf="showToggleButton(tool) && expandedTools[i]">

                      <div *ngIf="tool.url" class="d-flex align-items-center mb-2">
                        <span class="badge badge-info mr-2">{{ tool.methodType }}</span>
                        <span class="break-long-text toolurl">{{ tool.url }}</span>
                      </div>

                      <mat-accordion multi="true" displayMode="flat">

                        <!-- Headers -->
                        <mat-expansion-panel *ngIf="tool.url && hasEntries(tool.headers)" class="tool-panel">
                          <mat-expansion-panel-header>
                            <mat-panel-title>Headers</mat-panel-title>
                          </mat-expansion-panel-header>
                          <div *ngFor="let h of tool.headers | keyvalue" class="d-flex justify-content-between">
                            <span>{{ h.key }}</span>
                            <span class="break-long-text">{{ h.value }}</span>
                          </div>
                        </mat-expansion-panel>

                        <!-- Query string -->
                        <mat-expansion-panel *ngIf="tool.url && hasEntries(tool.queryString)" class="tool-panel">
                          <mat-expansion-panel-header>
                            <mat-panel-title>Query string</mat-panel-title>
                          </mat-expansion-panel-header>
                          <div *ngFor="let q of tool.queryString | keyvalue" class="d-flex justify-content-between">
                            <span>{{ q.key }}</span>
                            <span class="break-long-text">{{ q.value }}</span>
                          </div>
                        </mat-expansion-panel>

                        <!-- Body / Input  -->
                        <mat-expansion-panel *ngIf="tool.body" class="tool-panel">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <ng-container [ngSwitch]="true">
                                Body <span class="text-muted ml-1">({{ tool.bodyType }})</span>
                              </ng-container>
                            </mat-panel-title>
                          </mat-expansion-panel-header>

                          <ng-template matExpansionPanelContent>
                            <pre class="pre-wrap">{{ prettyJson(tool.body) }}</pre>
                          </ng-template>
                        </mat-expansion-panel>

                        <!-- Arguments (tools without body, ex. WebSearch) -->
                        <mat-expansion-panel *ngIf="!tool.body && tool.arguments" class="tool-panel">
                          <mat-expansion-panel-header>
                            <mat-panel-title>Arguments</mat-panel-title>
                          </mat-expansion-panel-header>

                          <ng-template matExpansionPanelContent>
                            <pre class="pre-wrap">{{ prettyJson(tool.arguments) }}</pre>
                          </ng-template>
                        </mat-expansion-panel>

                        <!-- Response -->
                        <mat-expansion-panel *ngIf="tool.httpResponseBody || (tool.errorMessage!=null && tool.errorMessage !='')" class="tool-panel">
                          <mat-expansion-panel-header>
                            <mat-panel-title>Response</mat-panel-title>
                          </mat-expansion-panel-header>

                          <ng-container *ngIf="tool.httpResponseBody">
                            <pre class="pre-wrap">{{ prettyJson(tool.httpResponseBody) }}</pre>
                          </ng-container>

                          <ng-container *ngIf="tool.errorMessage!=null && tool.errorMessage !=''">
                            {{tool.errorMessage}}
                          </ng-container>

                        </mat-expansion-panel>

                      </mat-accordion>

                    </div>
                  </div>
                  <div class="message-participant mr-1">Agent <span *ngIf="msg.item.agentName != null && msg.item.agentName !=''">"{{msg.item.agentName}}"</span></div>
                </ng-container>
              </div>

              <div class="chat-thinking" *ngIf="msg.type=='Thinking' && msg.item?.text">
                <details class="thinking-box">
                  <summary>
                    <i class="lni-bulb"></i>
                    <span class="thinking-label">Thinking</span>
                    <span class="thinking-preview">{{ msg.item.text }}</span>
                  </summary>
                  <div class="thinking-text">{{ msg.item.text }}</div>
                </details>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
